/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import "./global/global.css";

import { connect } from "react-redux";
import { fetchDashboardData, fetchAnalyticsData } from "../../actions/addLinkedAccounts.js";
import AddClient from "./assets/addClient.png";
import NotificationCards from "./global/components/NotificationCards";

// import ReceivedIcon from "./assets/received.png";
import ReceivedIconG from "./assets/receivedG.png";

// import ProofOfFundsOpenIcon from "./assets/msgOpen.png";
import ProofOfFundsOpenIconG from "./assets/msgOpenG.png";

// import ProofOfFundsSentIcon from "./assets/msgTick.png";
import ProofOfFundsSentIconG from "./assets/msgTickG.png";

// import MessgaeReplyIcon from "./assets/msgList.png";
import MessgaeReplyIconG from "./assets/msgListG.png";

import { Card, CardContent, Grid, Link, Typography } from "@material-ui/core";
import NoNotifications from "./assets/noti.png";
import DashboardCard from "./global/components/DashboardCard.js";
import AnalyticsMetrics from "./global/components/AnalyticsMetrics.js";

const managerContacts = [
  {
    title: "Deal Program Manager",
    email: "deal-coordinator@fastrealty.bot",
    description:
      "Email your deal details and documents to build a closing plan, track milestones, and coordinate follow-ups with everyone involved.",
  },
  {
    title: "Rental Manager",
    email: "kate@fastrealty.bot",
    description:
      "Email your rental property details and photos to create a rental listing and gather the information needed to get it ready to publish.",
  },
  {
    title: "Marketing Manager",
    email: "marketing-manager@fastrealty.bot",
    description:
      "Email your property details and photos to create PDF flyers, social media posts, and a property website. Reply to request revisions.",
  },
];

const dashBoardCardData = [
  {
    icon: AddClient,
    iconAlt: "Onboard New Client",
    title: "Onboard New Client",
    description:
      "Seamlessly register and onboard new clients.",
    beta: true,
    agentType: "Concierge",
  },
];

const Dashboard = (props) => {
  console.log("props", props);

  const dispatch = props.dispatch;
  const {
    dashboardData,
    analyticsData,
    analyticsLoading,
    analyticsError,
  } = props;


  useEffect(() => {
    dispatch(fetchDashboardData());
    dispatch(fetchAnalyticsData());
  }, []);

  const notifications = dashboardData?.events || [];




  const getNotificationIcon = (msgStatus) => {
    switch (msgStatus) {
      case "Proof-of-funds Request Email Sent.":
        return ProofOfFundsSentIconG;
      case "Proof-of-funds Request Email Opened.":
        return ProofOfFundsOpenIconG;
      case "Proof-of-funds Request sent to Bank":
        return MessgaeReplyIconG;
      case "Proof-of-funds Report received from Bank":
        return ReceivedIconG;
      default:
        return ProofOfFundsSentIconG;
    }
  };

  // Function to render a single notification card
  const renderNotificationCard = (evt, idx) => {
    switch (evt.type) {
      case 1: // message event type
        let msg = evt.message;
        return (
          <NotificationCards
            key={msg.id || idx}
            heading={evt.subject || "New Message"}
            email={msg.to_user}
            time={new Date(msg.message_date).toDateString()}
            icon={getNotificationIcon(msg.message_status)}
          />
        );
      case 2: // call list event type
        const card = (
          <NotificationCards
            key={evt.id || idx}
            heading={evt.subject || "Event Update"}
            sub={evt.body}
            time={new Date(evt.date).toDateString()}
            icon={ReceivedIconG}
            linkURL={`/call-list`}
          />
        );
        return card;
      case 3: // email campaign event type
        return (
          <NotificationCards
            key={evt.id || idx}
            heading={evt.subject || "Event Update"}
            sub={evt.body}
            time={new Date(evt.date).toDateString()}
            icon={ReceivedIconG}
            linkURL={`/call-list`}
          />
        );
      default:
        console.log("evt.type does not match any case", evt.type);
        return null;
    }
  };

  return (
    <>
      <div className="dashboard-root">
        {/* <Header /> */}

        <div className="db-container">

          {/* <Header /> */}

          <div className="dashboard">
            <div className="dashboard-container">
              <div className="dashboard-content">
                <h3>Dashboard</h3>
                <p>Email a manager below to get started, or use the dashboard tools.</p>
              </div>
              <Grid container spacing={3} style={{ marginBottom: "30px" }}>
                {managerContacts.map((manager) => (
                  <Grid item xs={12} sm={6} lg={4} key={manager.email}>
                    <Card variant="outlined" style={{ height: "100%", borderRadius: 17 }}>
                      <CardContent>
                        <Typography component="h4" variant="h6" gutterBottom>
                          {manager.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" paragraph>
                          {manager.description}
                        </Typography>
                        <Link
                          href={`mailto:${manager.email}`}
                          variant="body2"
                          underline="always"
                          style={{ overflowWrap: "anywhere" }}
                        >
                          {manager.email}
                        </Link>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              <Grid container spacing={3}>
                {dashBoardCardData.map((card, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={4} key={index}>
                    <DashboardCard
                      icon={card.icon}
                      title={card.title}
                      description={card.description}
                      link={card.link}
                      beta={card.beta}
                      iconAlt={card.iconAlt}
                      agentType={card.agentType}
                    />
                  </Grid>
                ))}
                {/* <Grid item xs={4}>
                  <DashboardCard
                    title={"Proof of Funds Request"}
                    description={
                      "Seamlessly answer frequently asked questions from new  realtors."
                    }
                    link={"/requestreport"}
                  />
                </Grid>
                <Grid item xs={4}>
                  <DashboardCard
                    title={"House Staging Services"}
                    description={
                      "Provide clients with instant information and booking options for house staging."
                    }
                    status={"Enabled"}
                  />
                </Grid>
                <Grid item xs={4}>
                  <DashboardCard
                    title={"Closing Document FAQs"}
                    description={
                      "Assists clients by instantly answering common questions about closing documents."
                    }
                    status={"Enabled"}
                  />
                </Grid> */}
              </Grid>

              <div style={{ marginTop: "30px" }}>
                <AnalyticsMetrics
                  analyticsData={analyticsData}
                  analyticsLoading={analyticsLoading}
                  analyticsError={analyticsError}
                />
              </div>

              {/* <div className="dashboard-cards-list">
                {dashBoardCardData.map((card, index) => (
                  <DashboardCards
                    key={index}
                    icon={card.icon}
                    title={card.title}
                    link={card.link}
                    pdr={index === dashBoardCardData.length - 1 ? "pdr" : ""}
                    subText={card?.subText}
                    isBeta={card?.isBeta}
                  />
                ))}
              </div> */}
            </div>
          </div>

          <div className="n" style={{ paddingBottom: "45px" }}>
            <div className="notifications">
              <h3>Notifications</h3>
              <div className="count-box">
                <p>{notifications.length}</p>
              </div>
            </div>
            {/* <NotificationCards /> */}

            <div className="not-card-list-container">
              {notifications.length > 0 ? (
                notifications.map(renderNotificationCard)
              ) : (
                <div className="no-not">
                  <img
                    src={NoNotifications}
                    alt="no-notifications"
                    style={{ height: "250px", width: "319px" }}
                  />
                  <p
                    style={{ paddingLeft: "1rem", color: "black" }}
                    className="no-notifications"
                  >
                    No notifications found.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect((state) => ({
  dashboardData: state.dashboardData,
  analyticsData: state.analyticsData,
  analyticsLoading: state.analyticsLoading,
  analyticsError: state.analyticsError,
}))(Dashboard);
